import { Component } from "react"
import PropTypes from "prop-types"

import Endpoints from "./endpoints"
import Logs from "./logs"
import AppletFeedback from "../applet_feedback/main"
import PlatformFeedbackPage from "../platform_feedback/platform_feedback_page"

class DynamicApplet extends Component {
  constructor(props) {
    super(props)

    const { hash } = window.location
    let tab = ""
    if (hash == "#logs") {
      tab = "logs"
    } else if (hash === "#feedback" || (this.props.published && !hash)) {
      tab = "feedback"
    } else {
      tab = "endpoints"
    }
    window.history.replaceState({}, null, `#${tab}`)

    this.state = {
      tab,
    }
  }

  changeTab = tab => {
    this.setState(
      {
        tab,
      },
      () => window.history.replaceState({}, null, `#${tab}`)
    )
  }

  render() {
    return (
      <>
        <nav className="applet-preview-nav tabbed-nav">
          <ul>
            {this.props.published && (
              <li className={this.state.tab == "feedback" ? "active" : null}>
                <a onClick={() => this.changeTab("feedback")}>User feedback</a>
              </li>
            )}
            <li className={this.state.tab == "endpoints" ? "active" : null}>
              <a onClick={() => this.changeTab("endpoints")}>Endpoints</a>
            </li>
            <li className={this.state.tab == "logs" ? "active" : null}>
              <a onClick={() => this.changeTab("logs")}>API logs</a>
            </li>
          </ul>
        </nav>
        <div className="applet-preview-section">
          {this.state.tab === "feedback" ? (
            <>
              <AppletFeedback
                tip_title={this.props.applet_feedback.tip_title}
                tip_subtitle={this.props.applet_feedback.tip_subtitle}
                tips_list={this.props.applet_feedback.tips_list}
                docs_applets_path={
                  this.props.applet_feedback.docs_connections_path
                }
                applet_opinion_count={
                  this.props.applet_feedback.applet_opinion_count
                }
                applet_feedback_count={
                  this.props.applet_feedback.applet_feedback_count
                }
                positive_rating_percentage={
                  this.props.applet_feedback.positive_rating_percentage
                }
                negative_rating_percentage={
                  this.props.applet_feedback.negative_rating_percentage
                }
              />
              <div className="spacer">&nbsp;</div>
              <PlatformFeedbackPage
                contentType="applet"
                feedbackType="applet_feedback"
                appletId={this.props.id}
                profileUrl={this.props.profile_url}
              />
            </>
          ) : this.state.tab === "endpoints" ? (
            <Endpoints {...this.props} />
          ) : (
            <Logs {...this.props} />
          )}
        </div>
      </>
    )
  }
}

DynamicApplet.propTypes = {
  numeric_id: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  published: PropTypes.bool.isRequired,
  enabled_for_user: PropTypes.bool.isRequired,
  channels: PropTypes.arrayOf(
    PropTypes.shape({
      brand_color: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      image_url: PropTypes.string.isRequired,
      lrg_variant_image_url: PropTypes.string.isRequired,
      triggers: PropTypes.array,
      actions: PropTypes.array,
    })
  ),
  docs_url: PropTypes.string.isRequired,
  mktApiUrl: PropTypes.string.isRequired,
  connect_url: PropTypes.string.isRequired,
  channel_user_id: PropTypes.string.isRequired,
  channel_api_host: PropTypes.string.isRequired,
  action_values: PropTypes.object.isRequired,
  query_values: PropTypes.object.isRequired,
  profile_url: PropTypes.string.isRequired,
  transactions_url: PropTypes.string.isRequired,
  edit_url: PropTypes.string.isRequired,
  applet_feedback: PropTypes.shape({
    tip_title: PropTypes.string.isRequired,
    tip_subtitle: PropTypes.string.isRequired,
    tips_list: PropTypes.array.isRequired,
    docs_connections_path: PropTypes.string.isRequired,
    applet_feedback_count: PropTypes.object.isRequired,
    positive_rating_percentage: PropTypes.number,
    negative_rating_percentage: PropTypes.number,
    applet_opinion_count: PropTypes.object.isRequired,
  }),
  actions: PropTypes.array,
  queries: PropTypes.array,
  triggers: PropTypes.array,
  request_types: PropTypes.array,
  respones_statuses: PropTypes.array,
  timeframes: PropTypes.array,
}

export default DynamicApplet
